import { SEVERITY } from "../lib/api";

export const SeverityBadge = ({ severity }) => {
  const s = SEVERITY[severity] || SEVERITY.info;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${s.bg} ${s.text} border ${s.border}`}
      data-testid={`severity-badge-${severity}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};
